import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, Route, Routes } from 'react-router-dom'
import { DashBikes } from '../../../assets/icons'
import { getBikes } from '../../../store/actions'
import { SearchBar, TableContainer } from '../../../UI'
import { columns } from './tableData'
import Container from './styles'
import RiderDetails from './RiderDetails'

const Bikes = () => {
  const [loading, setLoading] = useState(false)
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [searchVal, setSearchVal] = useState('')
  const [activePopup, setActivePopup] = useState(null)
  const [bikeLists, setBikeLists] = useState('')
  const { AdminData } = useSelector((s) => s)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    searchBikeLists()
  }, [AdminData.bikeLists, searchVal])

  useEffect(() => {
    dispatch(getBikes({}))
  }, [dispatch])

  const searchBikeLists = () => {
    setLoading(true)
    dispatch(getBikes({}, `?search=${searchVal}`)).then(
      ({...response }) => {
        setLoading(false)
          setBikeLists(response.data)
      },
    )
  }

  useEffect(() => {
    const handleClick = () => {
      setActivePopup()
    }
    document.addEventListener('click', handleClick)
    return () => {
      document.removeEventListener('click', handleClick)
    }
  }, [])

  const handleSearchInput = ({ target: { name, value } }) => {
    setSearchVal(value)
  }

  const handleDisplayMenu = (row, id) => {
    setActivePopup(id)
  }

  return (
    <Container>
      <Routes>
        <Route path="/view" element={<RiderDetails />} />
        <Route path="/" element={
          <>
            <header>
              <div className="top--row">
                <h2>Riders</h2>
                <DashBikes />
              </div>
              <div className="header--row">
                <SearchBar
                  placeholder="Search by name, email or phone"
                  handleSearch={searchBikeLists}
                  onChange={handleSearchInput}
                  loading={loading}
                />
              </div>
            </header>
            <div className="bikes--content__container">
              <TableContainer
                loading={bikeLists === ''}
                columns={columns({
                  handleDisplayMenu,
                  activePopup,
                  deleteLoading,
                  handleEdit: (row) => {
                    // Navigate to view rider details (read-only for admin)
                    navigate(`/dashboard/bikes/view`, {state: row})
                  },
                })}
                pagination={{
                  defaultCurrent: 1,
                  total: bikeLists?.pagination?.total,
                  onChange: (page) => {
                    setLoading(true)
                    dispatch(getBikes({ page })).finally(() => setLoading(false))
                  },
                }}
                dataSource={bikeLists}
              />
            </div>
          </>
        } />
      </Routes>
    </Container>
  )
}

export default Bikes
